import { DateRange } from 'react-day-picker';
import { fromZonedTime } from 'date-fns-tz';

const isValidDate = (date: Date | undefined): date is Date =>
  date instanceof Date && !isNaN(date.getTime());

export const zonedDateRangeToUtc = (
  dateRange: DateRange | undefined,
  timeZone: string,
): DateRange | undefined => {
  if (!dateRange) {
    return undefined;
  }

  const from = isValidDate(dateRange.from)
    ? fromZonedTime(dateRange.from, timeZone)
    : undefined;
  const to = isValidDate(dateRange.to)
    ? fromZonedTime(dateRange.to, timeZone)
    : undefined;

  return { from, to };
};
